import {Utils} from "./utils";
import {TypeUtils} from "./type-utils";
import {TranslationMaps} from "../services/translation-loader.service";

export class TextUtils {

  private static _currentLanguage: 'en' | 'it' | 'es' | 'de' | 'fr' | 'nb' | 'ru' | 'pt-PT' | 'nl' | 'da' = 'en';

  // Initialize with empty maps to prevent errors during module loading
  // APP_INITIALIZER will replace these with real translations
  private static _textMaps: TranslationMaps = {
    en: {},
    it: {},
    es: {},
    de: {},
    fr: {},
    nb: {},
    ru: {},
    'pt-PT': {},
    nl: {},
    da: {},
  };

  // create a regex to replace >br/> with \n
  private static brRegex = new RegExp('<br/>', 'g');
  private static templateMatcher: RegExp = /{{\s?([^{}\s]*)\s?}}/g;

  public static setTextMaps(maps: TranslationMaps): void {
    TextUtils._textMaps = maps;
  }

  public static setLanguage(language: 'en' | 'it' | 'es' | 'de' | 'fr' | 'nb' | 'ru' | 'pt-PT' | 'nl' | 'da'): void {
    if (['en', 'it', 'es', 'de', 'fr', 'nb', 'ru', 'pt-PT', 'nl', 'da'].includes(language)) {
      TextUtils._currentLanguage = language;
    }
  }

  public static getCurrentLanguage(): string {
    return TextUtils._currentLanguage;
  }

  private static getCurrentTextMap(): any {
    return TextUtils._textMaps[TextUtils._currentLanguage];
  }

  public static getText(text: string, params: any = null, customString: string = null): string {
    const currentTextMap = TextUtils.getCurrentTextMap();
    return TextUtils.interpolateString(customString ? customString : currentTextMap[text], params) || `TEXT_NOT_FOUND::${text}`;
  }

  private static interpolateString(string: string, params: any): string {
    if (!string) {
      return '';
    }
    if (!params) {
      return string;
    }
    return string.replace(TextUtils.templateMatcher, (substring: string, paramKeyChain: string) => {
      const value = Utils.getValueByKeyChain(params, paramKeyChain);
      return TypeUtils.isDefined(value) ? value : substring;
    });
  }

  public static pointToDecimal(value: string) {
    if (value.startsWith('.')) {
      return `0${value}`;
    }
    return value;
  }

}
